import React from "react";
import MenuButtonBox from "./MenuButtonBox";

export default function MenuWrapper() {
  return (
    <MenuButtonBox />
  );
}
